import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ResendOtpRepository } from '../repository/resend-otp-repository';
import { environment } from '../../../environments/environment';
import { ResendOtpRequest } from '../models/resend-otp.model';

@Injectable({
  providedIn: 'root',
})
export class ResendOtpApiImpl implements ResendOtpRepository {

  constructor(private readonly http: HttpClient){}

  resendOtp(payload: ResendOtpRequest
  ): Observable<void> {
    return this.http.post<void>(`${environment.URL_CORPORATIVE_USERS}/otp/send`, payload);
  }
}
